import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';
import { useDebouncedCallback } from 'use-debounce';
import { useTranslations } from '../../hooks/use_translations.js';
import { spacing1x, spacing2x } from '../../styles/spacing.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { isMantleComponentOfType, bindRefs } from '../../utils/react.js';
import { Button } from '../Button/Button.js';
import '../Icons/IconActivity.js';
import '../Icons/IconActivityFilled.js';
import '../Icons/IconActivityOff.js';
import '../Icons/IconAdd.js';
import '../Icons/IconAddToCart.js';
import '../Icons/IconAlignBottom.js';
import '../Icons/IconAlignCenter.js';
import '../Icons/IconAlignJustify.js';
import '../Icons/IconAlignLeft.js';
import '../Icons/IconAlignMiddle.js';
import '../Icons/IconAlignRight.js';
import '../Icons/IconAlignTop.js';
import '../Icons/IconAnnotate.js';
import '../Icons/IconApps.js';
import '../Icons/IconArchive.js';
import '../Icons/IconArrowBack.js';
import '../Icons/IconArrowDown.js';
import { IconArrowLeft } from '../Icons/IconArrowLeft.js';
import { IconArrowRight } from '../Icons/IconArrowRight.js';
import '../Icons/IconArrowUp.js';
import '../Icons/IconAskExpert.js';
import '../Icons/IconAtMention.js';
import '../Icons/IconAttach.js';
import '../Icons/IconBarChart.js';
import '../Icons/IconBold.js';
import '../Icons/IconCalendar.js';
import '../Icons/IconCalendarDay.js';
import '../Icons/IconCaretDown.js';
import '../Icons/IconCaretUp.js';
import '../Icons/IconCertification.js';
import '../Icons/IconCheck.js';
import '../Icons/IconClose.js';
import '../Icons/IconCloseContextualPanel.js';
import '../Icons/IconCloudSync.js';
import '../Icons/IconCloudUpload.js';
import '../Icons/IconCode.js';
import '../Icons/IconCollapsePanel.js';
import '../Icons/IconCollection.js';
import '../Icons/IconColor.js';
import '../Icons/IconColumns.js';
import '../Icons/IconComment.js';
import '../Icons/IconContentPlanner.js';
import '../Icons/IconCopy.js';
import '../Icons/IconCorporations.js';
import '../Icons/IconCRM.js';
import '../Icons/IconCustomDelivery.js';
import '../Icons/IconCustomize.js';
import '../Icons/IconDash.js';
import '../Icons/IconDatasource.js';
import '../Icons/IconDelete.js';
import '../Icons/IconDependentField.js';
import '../Icons/IconDocCenter.js';
import '../Icons/IconDownload.js';
import '../Icons/IconDrag.js';
import '../Icons/IconEdit.js';
import '../Icons/IconEditForm.js';
import '../Icons/IconEditNew.js';
import '../Icons/IconEmail.js';
import '../Icons/IconEmailBlast.js';
import '../Icons/IconEmailComponent.js';
import '../Icons/IconEmailTemplate.js';
import '../Icons/IconEmoji.js';
import '../Icons/IconEngagements.js';
import '../Icons/IconEvent.js';
import '../Icons/IconExpire.js';
import '../Icons/IconExport.js';
import '../Icons/IconExternal.js';
import '../Icons/IconFavoriteSelected.js';
import '../Icons/IconFavoriteUnselected.js';
import '../Icons/IconFile.js';
import '../Icons/IconFileAdd.js';
import '../Icons/IconFileEdit.js';
import '../Icons/IconFileLock.js';
import '../Icons/IconFileMove.js';
import '../Icons/IconFileRemove.js';
import '../Icons/IconFileSearch.js';
import '../Icons/IconFileShare.js';
import '../Icons/IconFileStar.js';
import '../Icons/IconFileSync.js';
import '../Icons/IconFileZip.js';
import '../Icons/IconFilter.js';
import '../Icons/IconFolder.js';
import '../Icons/IconFolderAdd.js';
import '../Icons/IconFolderEdit.js';
import '../Icons/IconFolderOpen.js';
import '../Icons/IconFolderRemove.js';
import '../Icons/IconFolderSearch.js';
import '../Icons/IconFolderShare.js';
import '../Icons/IconFolderStar.js';
import '../Icons/IconFolderSync.js';
import '../Icons/IconFolderTeam.js';
import '../Icons/IconFolderZip.js';
import '../Icons/IconFullscreen.js';
import '../Icons/IconGenericSort.js';
import '../Icons/IconGlobal.js';
import '../Icons/IconGoogleDrive.js';
import '../Icons/IconGrid.js';
import '../Icons/IconGridPattern1.js';
import '../Icons/IconGroupBy.js';
import '../Icons/IconHandClosed.js';
import '../Icons/IconHandOpen.js';
import '../Icons/IconHome.js';
import '../Icons/IconIndentDecrease.js';
import '../Icons/IconIndentIncrease.js';
import '../Icons/IconInsights.js';
import '../Icons/IconIntegrations.js';
import '../Icons/IconInternalSync.js';
import '../Icons/IconItalic.js';
import '../Icons/IconLaptop.js';
import '../Icons/IconLayout.js';
import '../Icons/IconLearningJourney.js';
import '../Icons/IconLesson.js';
import '../Icons/IconLibrary.js';
import '../Icons/IconLightbulb.js';
import '../Icons/IconLike.js';
import '../Icons/IconLikeDisabled.js';
import '../Icons/IconLineChart.js';
import '../Icons/IconLineHeight.js';
import '../Icons/IconLink.js';
import '../Icons/IconList.js';
import '../Icons/IconListNumbers.js';
import '../Icons/IconLiveSocial.js';
import '../Icons/IconLocate.js';
import '../Icons/IconLock.js';
import '../Icons/IconLogic.js';
import '../Icons/IconMedia.js';
import '../Icons/IconMediaCC.js';
import '../Icons/IconMediaCCActive.js';
import '../Icons/IconMediaControlPrevious.js';
import '../Icons/IconMediaForward.js';
import '../Icons/IconMediaFull.js';
import '../Icons/IconMediaLow.js';
import '../Icons/IconMediaMedium.js';
import '../Icons/IconMediaMute.js';
import '../Icons/IconMediaNext.js';
import '../Icons/IconMediaPause.js';
import '../Icons/IconMediaPlay.js';
import '../Icons/IconMediaRewind.js';
import '../Icons/IconMediaStop.js';
import '../Icons/IconMeetings.js';
import '../Icons/IconMenu.js';
import '../Icons/IconModule.js';
import '../Icons/IconMore.js';
import '../Icons/IconMove.js';
import '../Icons/IconMultiSelect.js';
import '../Icons/IconNews.js';
import '../Icons/IconNumeric.js';
import '../Icons/IconOpenContextualPanel.js';
import '../Icons/IconOpenPanel.js';
import '../Icons/IconPage.js';
import '../Icons/IconPageBack.js';
import '../Icons/IconPageDown.js';
import '../Icons/IconPageForward.js';
import '../Icons/IconPageUp.js';
import '../Icons/IconPaperclip.js';
import '../Icons/IconParagraph.js';
import '../Icons/IconPath.js';
import '../Icons/IconPieChart.js';
import '../Icons/IconPin.js';
import '../Icons/IconPortfolio.js';
import '../Icons/IconPresentation.js';
import '../Icons/IconPresentationMode.js';
import '../Icons/IconPreview.js';
import '../Icons/IconPreviewOff.js';
import '../Icons/IconPrint.js';
import '../Icons/IconProject.js';
import '../Icons/IconPublish.js';
import '../Icons/IconPublishing.js';
import '../Icons/IconPushNotification.js';
import '../Icons/IconPuzzlePiece.js';
import '../Icons/IconQuote.js';
import '../Icons/IconRecord.js';
import '../Icons/IconRecordActive.js';
import '../Icons/IconRedo.js';
import '../Icons/IconRefresh.js';
import '../Icons/IconRemoveFormatting.js';
import '../Icons/IconReorder.js';
import '../Icons/IconRequest.js';
import '../Icons/IconRotate.js';
import '../Icons/IconRSS.js';
import '../Icons/IconSave.js';
import '../Icons/IconScreen.js';
import '../Icons/IconScreenFitHeight.js';
import '../Icons/IconScreenFitWidth.js';
import '../Icons/IconScreenNext.js';
import '../Icons/IconScreenPrevious.js';
import '../Icons/IconScreenShare.js';
import '../Icons/IconSearch.js';
import '../Icons/IconSettings.js';
import '../Icons/IconShare.js';
import '../Icons/IconSharedLink.js';
import '../Icons/IconSingleSelect.js';
import '../Icons/IconSortDown.js';
import '../Icons/IconSortUp.js';
import '../Icons/IconSoundOff.js';
import '../Icons/IconSoundOn.js';
import '../Icons/IconStatusAdd.js';
import '../Icons/IconStatusAddFilled.js';
import '../Icons/IconStatusCheck.js';
import '../Icons/IconStatusCheckFilled.js';
import '../Icons/IconStatusClose.js';
import '../Icons/IconStatusCloseFilled.js';
import '../Icons/IconStatusDot.js';
import '../Icons/IconStatusError.js';
import '../Icons/IconStatusHelp.js';
import '../Icons/IconStatusHelpFilled.js';
import '../Icons/IconStatusInformation.js';
import '../Icons/IconStatusInformationFilled.js';
import '../Icons/IconStatusPause.js';
import '../Icons/IconStatusPauseFilled.js';
import '../Icons/IconStatusPlay.js';
import '../Icons/IconStatusPlayFilled.js';
import '../Icons/IconStatusRemove.js';
import '../Icons/IconStatusRemoveFilled.js';
import '../Icons/IconStatusUrgent.js';
import '../Icons/IconStatusUrgentFilled.js';
import '../Icons/IconStatusWarning.js';
import '../Icons/IconSubtask.js';
import '../Icons/IconSync.js';
import '../Icons/IconTableColumn.js';
import '../Icons/IconTableGrid.js';
import '../Icons/IconTableRow.js';
import '../Icons/IconTags.js';
import '../Icons/IconTask.js';
import '../Icons/IconTasks.js';
import '../Icons/IconTaxonomy.js';
import '../Icons/IconTemplate.js';
import '../Icons/IconText.js';
import '../Icons/IconTextCleared.js';
import '../Icons/IconTextField.js';
import '../Icons/IconTextImageLeft.js';
import '../Icons/IconTextImageRight.js';
import '../Icons/IconTextIndentLeft.js';
import '../Icons/IconTextIndentRight.js';
import '../Icons/IconTextSingle.js';
import '../Icons/IconTextSize.js';
import '../Icons/IconTextStrikethrough.js';
import '../Icons/IconTextSubscript.js';
import '../Icons/IconTextSuperscript.js';
import '../Icons/IconTextUnderline.js';
import '../Icons/IconTrendingDown.js';
import '../Icons/IconTrendingUp.js';
import '../Icons/IconTrueFalse.js';
import '../Icons/IconTv.js';
import '../Icons/IconTwoColumn.js';
import '../Icons/IconUndo.js';
import '../Icons/IconUnlike.js';
import '../Icons/IconUnlink.js';
import '../Icons/IconUnlock.js';
import '../Icons/IconUnpublish.js';
import '../Icons/IconUpload.js';
import '../Icons/IconUser.js';
import '../Icons/IconUserAdd.js';
import '../Icons/IconUserAddToMeeting.js';
import '../Icons/IconUserGroup.js';
import '../Icons/IconUserRating.js';
import '../Icons/IconUserRemove.js';
import '../Icons/IconUserSearch.js';
import '../Icons/IconUserSettings.js';
import '../Icons/IconUserShare.js';
import '../Icons/IconUserSync.js';
import '../Icons/IconVariables.js';
import '../Icons/IconVideo.js';
import '../Icons/IconVideoPause.js';
import '../Icons/IconVideoRewind15.js';
import '../Icons/IconVideoSkip15.js';
import '../Icons/IconWorkspace.js';
import '../Icons/IconZoomIn.js';
import '../Icons/IconZoomOut.js';
import { StyledTab } from '../TabsTab/StyledTab.js';
import { scrollHorizontally, getOverflowStates } from './utils.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

var _excluded = ["bgColor", "children", "endAdornment", "focusableOverflowNav", "selectedTabSelector"];
var TabList = styled.div.withConfig({
  displayName: "StyledTabList__TabList",
  componentId: "sc-f75htv-0"
})(["&&{width:100%;overflow-x:auto;padding:", ";width:100%;display:flex;scrollbar-width:none;-ms-overflow-style:-ms-autohiding-scrollbar;}&&::-webkit-scrollbar{display:none;}&&:focus{outline:none;}"], function (props) {
  return props.hasOverflowIndicator ? "".concat(spacing1x) : "".concat(spacing1x, " 2px");
});
var OverflowIndicator = styled.div.withConfig({
  displayName: "StyledTabList__OverflowIndicator",
  componentId: "sc-f75htv-1"
})(["&&{z-index:1;flex:0 0 ", ";height:36px;}"], spacing2x);
var EndOverflowIndicator = styled(OverflowIndicator).withConfig({
  displayName: "StyledTabList__EndOverflowIndicator",
  componentId: "sc-f75htv-2"
})(["&&{background-image:", ";margin-inline-start:-", ";}"], function (_ref) {
  var bgColor = _ref.bgColor,
    isRTL = _ref.isRTL,
    theme = _ref.theme;
  return "linear-gradient(to ".concat(isRTL ? "left" : "right", ", #ffffff00, ").concat(bgColor || theme.neutralColors.pearl, ")");
}, spacing2x);
var StartOverflowIndicator = styled(OverflowIndicator).withConfig({
  displayName: "StyledTabList__StartOverflowIndicator",
  componentId: "sc-f75htv-3"
})(["&&{background-image:", ";margin-inline-end:-", ";}"], function (_ref2) {
  var bgColor = _ref2.bgColor,
    isRTL = _ref2.isRTL,
    theme = _ref2.theme;
  return "linear-gradient(to ".concat(isRTL ? "right" : "left", ", #ffffff00, ").concat(bgColor || theme.neutralColors.pearl, ")");
}, spacing2x);
var TabListWrapper = styled.div.withConfig({
  displayName: "StyledTabList__TabListWrapper",
  componentId: "sc-f75htv-4"
})(["&&{height:36px;min-width:0%;}"]);
var OverflowWrapper = styled.div.withConfig({
  displayName: "StyledTabList__OverflowWrapper",
  componentId: "sc-f75htv-5"
})(["&&{position:relative;display:flex;width:100%;align-items:center;", ";}"], function (props) {
  return !props.hasOverflowIndicator ? "margin: 0 -".concat(spacing1x, ";") : "";
});
var EndAdornmentWrapper = styled.div.withConfig({
  displayName: "StyledTabList__EndAdornmentWrapper",
  componentId: "sc-f75htv-6"
})(["&&{margin-inline-start:", ";flex:1 1 auto;}"], spacing2x);
var BottomBorder = styled.div.withConfig({
  displayName: "StyledTabList__BottomBorder",
  componentId: "sc-f75htv-7"
})(["&&{border-bottom:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return "solid 1px " + theme.neutralColors.silver;
});
var StyledTabList = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var bgColor = _ref4.bgColor,
    children = _ref4.children,
    endAdornment = _ref4.endAdornment,
    focusableOverflowNav = _ref4.focusableOverflowNav,
    selectedTabSelector = _ref4.selectedTabSelector,
    rest = _objectWithoutProperties(_ref4, _excluded);
  var _React$useState = React.useState([0, 0]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    _React$useState2$ = _slicedToArray(_React$useState2[0], 2),
    startOverflowNav = _React$useState2$[0],
    endOverflowNav = _React$useState2$[1],
    setOverflowNav = _React$useState2[1];
  var _React$useState3 = React.useState(void 0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    showTooltip = _React$useState4[0],
    setShowTooltip = _React$useState4[1];
  var _useThemeContext = useThemeContext(),
    isRTL = _useThemeContext.isRTL,
    localization = _useThemeContext.localization;
  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
    t = _useTranslations.t;
  var tablistRef = React.useRef(null);
  function handleOverflow() {
    if (!(tablistRef !== null && tablistRef !== void 0 && tablistRef.current)) return;
    var _tablistRef$current = tablistRef.current,
      clientWidth = _tablistRef$current.clientWidth,
      scrollLeft = _tablistRef$current.scrollLeft,
      scrollWidth = _tablistRef$current.scrollWidth;
    setShowTooltip(void 0);
    setOverflowNav(getOverflowStates(Math.round(clientWidth), Math.round(-scrollLeft), Math.round(scrollWidth)));
  }
  var debouncedHandleOverflow = useDebouncedCallback(handleOverflow, 25);
  React.useEffect(function () {
    window.addEventListener("resize", debouncedHandleOverflow);
    handleOverflow();
    return function () {
      return window.removeEventListener("resize", debouncedHandleOverflow);
    };
  }, []);
  var shouldAutoScrollOnce = React.useRef(true);
  var shouldScroll = shouldAutoScrollOnce.current;
  React.useEffect(function () {
    if (startOverflowNav && endOverflowNav && shouldScroll) {
      shouldAutoScrollOnce.current = false;
      var selectedTab = tablistRef.current ? tablistRef.current.querySelector(selectedTabSelector) : void 0;
      var parentElement = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.parentElement;
      if (parentElement && typeof parentElement.scrollIntoView === "function") {
        parentElement.scrollIntoView({
          block: "nearest",
          inline: "center"
        });
      } else if (process.env.NODE_ENV !== "production") {
        console.error("`TabList` found no selected tab. Scrolling into view is disabled.");
      }
    }
  }, [startOverflowNav, endOverflowNav, selectedTabSelector, shouldScroll]);
  var prevChildren = React.useRef(null);
  React.useEffect(function () {
    var childrenArray = React.Children.toArray(children);
    var prevChildrenArray = React.Children.toArray(prevChildren.current);
    var shouldUpdate = childrenArray.length !== prevChildrenArray.length;
    if (!shouldUpdate) {
      shouldUpdate = childrenArray.some(function (c, i) {
        var prevChild = prevChildrenArray[i];
        return !isEqual(isMantleComponentOfType(c, StyledTab) ? c.props.children : c, isMantleComponentOfType(prevChild, StyledTab) ? prevChild.props.children : void 0);
      });
    }
    if (shouldUpdate) {
      prevChildren.current = children;
      handleOverflow();
      shouldAutoScrollOnce.current = true;
    }
  }, [children]);
  var overflowNavProps = !focusableOverflowNav ? {
    tabIndex: -1,
    "aria-hidden": true
  } : {};
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(OverflowWrapper, {
      hasOverflowIndicator: !!startOverflowNav,
      children: [!!startOverflowNav && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Button, _objectSpread(_objectSpread({}, overflowNavProps), {}, {
          disabled: startOverflowNav === -1,
          hideLabel: true,
          label: isRTL ? t("Tabs.scrollRight") : t("Tabs.scrollLeft"),
          startAdornment: IconArrowLeft,
          style: {
            marginInlineStart: spacing1x,
            marginInlineEnd: spacing1x
          },
          variant: "ghost",
          onClick: function onClick() {
            return scrollHorizontally(tablistRef.current, isRTL ? 1 : -1);
          }
        })), /*#__PURE__*/jsx(StartOverflowIndicator, {
          isRTL: isRTL,
          bgColor: bgColor
        })]
      }), /*#__PURE__*/jsx(TabListWrapper, {
        children: /*#__PURE__*/jsx(TabList, _objectSpread(_objectSpread({}, rest), {}, {
          hasOverflowIndicator: !!startOverflowNav,
          ref: bindRefs(ref, tablistRef),
          onScroll: function onScroll() {
            setShowTooltip(false);
            debouncedHandleOverflow();
          },
          children: React.Children.map(children, function (child) {
            if (isMantleComponentOfType(child, StyledTab)) {
              return /*#__PURE__*/React.cloneElement(child, {
                tooltipProps: _objectSpread(_objectSpread({}, child.props.tooltipProps), {}, {
                  showing: showTooltip
                }),
                onFocus: function onFocus(e) {
                  e.stopPropagation();
                  var parentElement = e.currentTarget.parentElement;
                  if (parentElement && typeof parentElement.scrollIntoView === "function") {
                    parentElement === null || parentElement === void 0 ? void 0 : parentElement.scrollIntoView({
                      block: "nearest",
                      inline: "nearest"
                    });
                  }
                  if (typeof child.props.onFocus === "function") child.props.onFocus(e);
                }
              });
            }
            return child;
          })
        }))
      }), !!endOverflowNav && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(EndOverflowIndicator, {
          isRTL: isRTL,
          bgColor: bgColor
        }), /*#__PURE__*/jsx(Button, _objectSpread(_objectSpread({}, overflowNavProps), {}, {
          disabled: endOverflowNav === -1,
          hideLabel: true,
          label: isRTL ? t("Tabs.scrollLeft") : t("Tabs.scrollRight"),
          startAdornment: IconArrowRight,
          style: {
            marginInlineStart: spacing1x,
            marginInlineEnd: "-".concat(spacing1x)
          },
          variant: "ghost",
          onClick: function onClick() {
            return scrollHorizontally(tablistRef.current, isRTL ? -1 : 1);
          }
        }))]
      }), /*#__PURE__*/jsx(EndAdornmentWrapper, {
        children: endAdornment
      })]
    }), /*#__PURE__*/jsx(BottomBorder, {})]
  });
});
StyledTabList.displayName = "StyledTabsList";

export { StyledTabList };
